const paths = {
  arrow: <><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></>,
  arrowLeft: <><path d="M19 12H5"/><path d="m11 6-6 6 6 6"/></>,
  expand: <><path d="M8 3H3v5"/><path d="M16 3h5v5"/><path d="M8 21H3v-5"/><path d="M16 21h5v-5"/></>,
  contract: <><path d="M3 8h5V3"/><path d="M21 8h-5V3"/><path d="M3 16h5v5"/><path d="M21 16h-5v5"/></>,
  wave: <path d="M3 12h2l2-5 3 10 3-14 3 18 3-9h2"/>,
  ear: <><path d="M6 10a6 6 0 1 1 12 0c0 4-3 4-3 7a3 3 0 0 1-6 0"/><path d="M9.5 10a2.5 2.5 0 0 1 5 0c0 2-1.5 2.5-2.5 3.5"/></>,
  table: <><path d="M4 5h16v14H4z"/><path d="M4 10h16M9 5v14M15 5v14"/></>,
  people: <><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="2.5"/><path d="M2 21v-2a6 6 0 0 1 12 0v2"/><path d="M14 21v-1.5a4.5 4.5 0 0 1 8 0V21"/></>,
  book: <><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5z"/></>,
  stethoscope: <><path d="M6 3v5a4 4 0 0 0 8 0V3"/><path d="M4 3h4M12 3h4"/><path d="M10 12v2a5 5 0 0 0 10 0v-1"/><circle cx="20" cy="10" r="2"/></>,
  play: <path d="m8 5 11 7-11 7z"/>,
  pause: <><path d="M8 5v14"/><path d="M16 5v14"/></>,
  reset: <><path d="M4 7V3h4"/><path d="M4 3l4 4"/><path d="M5 9a8 8 0 1 0 2-3"/></>,
  location: <><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></>,
  network: <><circle cx="12" cy="5" r="2"/><circle cx="5" cy="18" r="2"/><circle cx="19" cy="18" r="2"/><path d="M12 7v4M10.5 12 6 16M13.5 12 18 16"/></>,
  pulse: <path d="M2 12h4l2-6 4 12 3-9 2 3h5"/>,
  school: <><path d="m3 10 9-5 9 5-9 5z"/><path d="M5 12v7h14v-7M9 19v-5h6v5"/></>,
  map: <><path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15M15 6v15"/></>,
  external: <><path d="M14 4h6v6"/><path d="M10 14 20 4"/><path d="M20 14v6h-6"/><path d="M4 10V4h6"/><path d="M4 14v6h6"/></>,
};

export default function Icon({ name, className = '' }) {
  return (
    <svg className={`icon ${className}`} viewBox="0 0 24 24" aria-hidden="true">
      {paths[name] ?? paths.wave}
    </svg>
  );
}
